module.exports = __webpack_public_path__ + "static/scale-model-of-jones-point-lighthouse-in-alexandria-virginia-88d3f2bd686f32967e1a9b735524c055.png";